<script>
	import { createEventDispatcher } from "svelte";
	import { uiText } from "../lib/uiText.js";
	import {
		doc,
		setDoc, //
		getDoc,
		updateDoc,
		collection,
		addDoc, //
		// arrayUnion,
		// onSnapshot,
		// deleteField,
		serverTimestamp,
		// increment,
		// query,
		// limit,
		// orderBy,
	} from "firebase/firestore";

	const dispatch = createEventDispatcher();

	// export let auth;
	export let db;
	export let lang;
	export let loader;
	export let user;
	let ui = uiText(lang);
	$: lang,
		(ui = uiText(lang)),
		dispatch("setLang", { lang: lang, prefset: true });
	$: loader, dispatch("loader", loader), (ui = uiText(lang));

	let code_created = false;

	let codeSet = {
		product: "",
		code: "",
		single_use: true,
		allowed_uses: 1,
		unlimited: false,
		productName: "",
		ordered_by: "",
		issued_by: { name: user.name, uid: user.uid },
		vendor: "vg-admin",
	};

	// ------

	let query = "";
	let dataField = "";
	let data = "";

	function doParse() {
		console.log(dataField);
		data = JSON.parse(dataField);
		console.log(data);
	}

	async function doUpdate() {
		const docRef = doc(db, query);
		console.log(docRef);

		await updateDoc(docRef, { ...data }, { merge: true }).then(() => {
			console.log("DONE");
			alert("data updated");
		});
	}

	// $: dataField, (;

	// ------

	// async function saveCodeSet() {
	// 	let data = codeSet;

	// 	if (data.code == "") {
	// 		data.code = makeID(8);
	// 	}

	// 	let codeSetObject = {
	// 		product: data.product,
	// 		code: data.code,
	// 		game_on: false,
	// 		game_over: false,
	// 		used_by: null,

	// 		...(data.single_use == true && {
	// 			unlimited: false,
	// 		}),
	// 		...(data.single_use == false &&
	// 			data.unlimited == false && {
	// 				unlimited: data.allowed_uses,
	// 			}),

	// 		...(data.single_use == false &&
	// 			data.unlimited == true && {
	// 				unlimited: true,
	// 			}),

	// 		productName: data.productName,
	// 		ordered_by: data.ordered_by,
	// 		issued_by: data.issued_by,
	// 		vendor: data.vendor,
	// 	};

	// 	const codeSetRef = doc(db, "game-activation-codes", data.code);

	// 	const checkSnap = await getDoc(codeSetRef);

	// 	if (checkSnap.exists()) {
	// 		console.log("This code already exists!");
	// 		alert("This code already exists!");

	// 		if (confirm("Are you sure you want to update the code?")) {
	// 			console.log("Updating existing code...");
	// 			await updateDoc(codeSetRef, { ...codeSetObject }, { merge: true }).then(
	// 				() => {
	// 					console.log("DONE");
	// 					alert("Code updated");
	// 					code_created = true;
	// 				}
	// 			);
	// 		} else {
	// 			console.log("Nothing changed!");
	// 			alert("No changes were made.");
	// 		}
	// 	} else {
	// 		if (
	// 			confirm("This code doesn't exist. Are you sure you want to create it?")
	// 		) {
	// 			await setDoc(codeSetRef, { ...codeSetObject }, { merge: true }).then(
	// 				() => {
	// 					console.log("DONE");
	// 					alert("Code created");
	// 					code_created = true;
	// 				}
	// 			);
	// 		} else {
	// 			console.log("Nothing changed!");
	// 			alert("No changes were made.");
	// 		}
	// 	}
	// }

	// let temp;
	// let hasCC, hasBCC;
	// let emailSet = {
	// 	recepients: [codeSet.ordered_by],
	// 	cc: [],
	// 	bcc: [],
	// };
	// $: emailSet.recepients[0] = codeSet.ordered_by;

	// async function sendEmailWithCode() {
	// 	let query_doc;
	// 	switch (lang) {
	// 		case "en":
	// 			query_doc = "gamecode_email_template_en";
	// 			break;
	// 		case "bg":
	// 			query_doc = "gamecode_email_template_bg";
	// 			break;
	// 		default:
	// 			query_doc = "gamecode_email_template_en";
	// 	}

	// 	let email, html_compose, text_compose;

	// 	const emailSetRef = doc(db, "templates", query_doc);
	// 	const emailSnap = await getDoc(emailSetRef);

	// 	if (emailSnap.exists()) {
	// 		email = emailSnap.data();

	// 		html_compose = email.html
	// 			.replace("{{game_name}}", codeSet.productName)
	// 			.replace("{{game_code}}", codeSet.code);
	// 		text_compose = email.text
	// 			.replace("{{game_name}}", codeSet.productName)
	// 			.replace("{{game_code}}", codeSet.code);

	// 		console.log(text_compose);
	// 	} else {
	// 		console.log("No such document!");
	// 	}

	// 	const autoSendRef = collection(db, "autosendmail");

	// 	await addDoc(
	// 		autoSendRef,
	// 		{
	// 			to: emailSet.recepients,
	// 			cc: emailSet.cc,
	// 			bcc: emailSet.bcc,
	// 			message: {
	// 				subject: email.subject,
	// 				html: html_compose,
	// 				text: text_compose,
	// 			},
	// 			timeOfSending: serverTimestamp(),
	// 		},
	// 		{ merge: true }
	// 	).then(() => {
	// 		console.log("DONE");
	// 		alert("Mail sent!");
	// 	});
	// }
</script>

<!--  -->
<!--  -->
<!--  -->
<p class="mt-6 uppercase">VG Panel</p>
<h1>Firebase Update</h1>

<div class="md:grid flex flex-wrap">
	<div class="grid grow sm:grow-0">
		<label for="qry">Query:</label>
		<input
			type="text"
			name="qry"
			id="qry"
			bind:value={query}
			placeholder="Firebase Query"
			title="Firebase Query"
		/>
	</div>

	<div class="grid grow min-w-[50vw]">
		<label for="upd_data">Update Data:</label>
		<textarea
			class="text-blue-200 p-1 font-mono"
			type="text"
			name="upd_data"
			id="upd_data"
			bind:value={dataField}
			placeholder="Leave blank for random"
			title="Desired code"
		></textarea>
	</div>
</div>

<div class="grid flex-wrap sm:flex">
	<button on:click={doParse} class="order-first secondary grow sm:order-none">
		<i class="fa-solid fa-brackets-curly" data-position="left" />Parse</button
	>
	<button on:click={doUpdate} class="order-first secondary grow sm:order-none">
		<i class="fa-solid fa-floppy-disk" data-position="left" />Save Code</button
	>
</div>

<div class="grid gap-4">
	<code>{JSON.stringify(data)}</code>
</div>

<div class="grid gap-4">
	<h3>Templates:</h3>
	<pre>&lcub;
"reservationSlots":&lcub;
	"2308_1900_01":&lcub;"available":true,"displayName":"23.08.2025 — 19:00"&rcub;,
	"2308_1900_02":&lcub;"available":true,"displayName":"23.08.2025 — 19:00"&rcub;,
	"2308_1900_03":&lcub;"available":true,"displayName":"23.08.2025 — 19:00"&rcub;,
	"2308_1900_04":&lcub;"available":true,"displayName":"23.08.2025 — 19:00"&rcub;,
	"2308_1900_05":&lcub;"available":true,"displayName":"23.08.2025 — 19:00"&rcub;,
	"2308_1900_06":&lcub;"available":true,"displayName":"23.08.2025 — 19:00"&rcub;,
	"2308_1900_07":&lcub;"available":true,"displayName":"23.08.2025 — 19:00"&rcub;,
	"2308_1900_08":&lcub;"available":true,"displayName":"23.08.2025 — 19:00"&rcub;,
	"2308_1900_09":&lcub;"available":true,"displayName":"23.08.2025 — 19:00"&rcub;,
	"2308_1900_10":&lcub;"available":true,"displayName":"23.08.2025 — 19:00"&rcub;,

	"2308_2000_01":&lcub;"available":true,"displayName":"23.08.2025 — 20:00"&rcub;,
	"2308_2000_02":&lcub;"available":true,"displayName":"23.08.2025 — 20:00"&rcub;,
	"2308_2000_03":&lcub;"available":true,"displayName":"23.08.2025 — 20:00"&rcub;,
	"2308_2000_04":&lcub;"available":true,"displayName":"23.08.2025 — 20:00"&rcub;,
	"2308_2000_05":&lcub;"available":true,"displayName":"23.08.2025 — 20:00"&rcub;,
	"2308_2000_06":&lcub;"available":true,"displayName":"23.08.2025 — 20:00"&rcub;,
	"2308_2000_07":&lcub;"available":true,"displayName":"23.08.2025 — 20:00"&rcub;,
	"2308_2000_08":&lcub;"available":true,"displayName":"23.08.2025 — 20:00"&rcub;,
	"2308_2000_09":&lcub;"available":true,"displayName":"23.08.2025 — 20:00"&rcub;,
	"2308_2000_10":&lcub;"available":true,"displayName":"23.08.2025 — 20:00"&rcub;,

	"2308_2100_01":&lcub;"available":true,"displayName":"23.08.2025 — 21:00"&rcub;,
	"2308_2100_02":&lcub;"available":true,"displayName":"23.08.2025 — 21:00"&rcub;,
	"2308_2100_03":&lcub;"available":true,"displayName":"23.08.2025 — 21:00"&rcub;,
	"2308_2100_04":&lcub;"available":true,"displayName":"23.08.2025 — 21:00"&rcub;,
	"2308_2100_05":&lcub;"available":true,"displayName":"23.08.2025 — 21:00"&rcub;,
	"2308_2100_06":&lcub;"available":true,"displayName":"23.08.2025 — 21:00"&rcub;,
	"2308_2100_07":&lcub;"available":true,"displayName":"23.08.2025 — 21:00"&rcub;,
	"2308_2100_08":&lcub;"available":true,"displayName":"23.08.2025 — 21:00"&rcub;,
	"2308_2100_09":&lcub;"available":true,"displayName":"23.08.2025 — 21:00"&rcub;,
	"2308_2100_10":&lcub;"available":true,"displayName":"23.08.2025 — 21:00"&rcub;
&rcub;
&rcub;
</pre>
</div>

<style>
	:global(.obelisk select) {
		box-sizing: border-box;

		place-content: center;
		--tw-bg-opacity: 1;
		background-color: rgb(255 255 255 / var(--tw-bg-opacity));
	}
	:global(.obelisk select) {
		margin: 10px;
		padding: 15px;
		border-radius: 0px;
		box-shadow: #093a86 5px 5px 0;
		color: #05204a;
	}
</style>
